import React from 'react';
import { Link, router } from '@inertiajs/react';
import Layout from '../../../components/Layout.jsx';
import WebinarForm from './_Form.jsx';

export default function SuperadminWebinarsEdit({ webinar, statuses, visibilities, instructors = [] }) {
  const onDelete = () => {
    if (!confirm('Delete this webinar? Registrations will also be removed.')) return;
    router.delete(`/superadmin/webinars/${webinar.id}`);
  };

  return (
    <Layout>
      <div className="max-w-3xl mx-auto p-6 sm:p-8 space-y-6">
        <Link href={`/superadmin/webinars/${webinar.id}`} className="text-sm text-indigo-600 hover:text-indigo-700">← Back to webinar</Link>
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">Edit webinar</h1>
          <button
            type="button"
            onClick={onDelete}
            className="px-3 py-1.5 text-sm font-semibold rounded-lg border border-rose-200 text-rose-700 hover:bg-rose-50 cursor-pointer"
          >
            Delete
          </button>
        </div>
        <WebinarForm
          webinar={webinar}
          statuses={statuses}
          visibilities={visibilities}
          instructors={instructors}
          submitUrl={`/superadmin/webinars/${webinar.id}`}
          method="patch"
          submitLabel="Save changes"
          cancelHref={`/superadmin/webinars/${webinar.id}`}
        />
      </div>
    </Layout>
  );
}
